import { render, staticRenderFns } from "./AddressInfoBlock.vue?vue&type=template&id=7388b361&scoped=true&"
import script from "./AddressInfoBlock.vue?vue&type=script&lang=js&"
export * from "./AddressInfoBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7388b361",
  null
  
)

export default component.exports